import { render, staticRenderFns } from "./BellyFat.vue?vue&type=template&id=5702ed9f&"
import script from "./BellyFat.vue?vue&type=script&lang=js&"
export * from "./BellyFat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports